var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterFenceSRCone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37572 23.5345C11.2522 23.5345 14.3948 21.4654 14.3948 18.913C14.3948 16.3606 11.2522 14.2915 7.37572 14.2915C3.49922 14.2915 0.356689 16.3606 0.356689 18.913C0.356689 21.4654 3.49922 23.5345 7.37572 23.5345Z",
    fill: "#A06A38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3993 4.70142H0.356689V18.7441H14.3993V4.70142Z",
    fill: "#A06A38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37572 9.49192C11.2522 9.49192 14.3948 7.4228 14.3948 4.87041C14.3948 2.31802 11.2522 0.248901 7.37572 0.248901C3.49922 0.248901 0.356689 2.31802 0.356689 4.87041C0.356689 7.4228 3.49922 9.49192 7.37572 9.49192Z",
    fill: "#CB8E5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterFenceSRCone);
export default __webpack_public_path__ + "static/media/winter_fence_s_r_cone.cf85027cb190e0059987e818c34b0785.svg";
export { ForwardRef as ReactComponent };